import { mergeAttributes } from '../../global/ui-helpers';
import type { FieldControl, FieldOption } from '../fieldset/ui-fieldset.type';
import type { ElementConfig } from '../ui-element.type';

/**
 * Create an ElementConfig based on FieldControl.
 * @param {FieldControl} control
 * @returns {ElementConfig}
 * @private
 */
export function fromControlConfig(control: FieldControl): ElementConfig {
    const select = (control.control || {}) as FieldControl;
    const options: Array<ElementConfig> =
        'options' in select && select.options
            ? select.options.map((option: FieldOption) => {
                  const additional: Record<string, string> = {};
                  if (option.data) {
                      for (const key in option.data) {
                          if (
                              Object.prototype.hasOwnProperty.call(
                                  option.data,
                                  key
                              )
                          ) {
                              additional['data-' + key] = option.data[key];
                          }
                      }
                  }
                  return {
                      tagName: 'option',
                      attributes: mergeAttributes(
                          {
                              value: option.value,
                              selected:
                                  option.value === select.value ? '' : null,
                          },
                          additional
                      ),
                      children: [option.content ?? null],
                  };
              })
            : [];

    const selectConfig: ElementConfig = {
        tagName: 'select',
        attributes: select.attributes,
        children: options,
    };

    return {
        tagName: 'ui-dropdown',
        attributes: control.attributes,
        children: [selectConfig],
    };
}
